import {
  Box,
  Stack,
  Typography,
  Button,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { PlusIcon } from '@fortress-technology-solutions/fortress-component-library/Icons';
import React from 'react';
import EditModeUI from './EditModeUI';
import ReadOnlyUI from './ReadOnlyUI';
import type { Props, UIProps } from './types';
import { useFinalDecisionFormUIProps } from './hooks';
import messages from '../messages';
import AdverseActionLetterModal from '../AdverseActionLetterModal';
import useModalProps from '../../../hooks/useModalProps';

function FinalDecisionForm(props: Props) {
  const uiProps = useFinalDecisionFormUIProps(props);
  return <UI {...uiProps} />;
}

function UI({
  intl,
  onSaveFinalDecision,
  decisionDate,
  decisionUserFullName,
  finalScreeningStatus,
  isReadOnly,
  reasonForDecision,
  onEditFinalDecision,
  onCancelEdit,
  isCreateAdverseActionLetterShown,
  isApplicationCanceledOrDenied,
  promptToaster,
  adverseActionDeadlineDays,
  applicationId,
  screeningLetterTypes,
  organizationId,
  propertyId,
  screeningData,
  isResident,
}: UIProps) {
  const readOnlyProps = {
    intl,
    finalScreeningStatus,
    reasonForDecision,
    onEditFinalDecision,
    isApplicationCanceledOrDenied,
    isResident,
  };
  const editModeProps = {
    intl,
    onSaveFinalDecision,
    finalScreeningStatus,
    reasonForDecision,
    onCancelEdit,
  };
  const createAdverseActionLetterModalProps = useModalProps();

  return (
    <Stack>
      <Box
        sx={{
          borderRadius: '4px',
          border: '1px solid #D1D1D1',
          backgroundColor: '#F8F8F8',
          padding: 3,
        }}
      >
        {isReadOnly || isResident ? (
          <ReadOnlyUI {...readOnlyProps} />
        ) : (
          <EditModeUI {...editModeProps} />
        )}
      </Box>
      {decisionDate && decisionUserFullName && (isReadOnly || isResident) && (
        <Typography
          variant="bodySmall"
          color="text.secondary"
          flexItem
          alignSelf="flex-end"
          marginTop={0.5}
        >
          {intl.formatMessage(messages.finalScreeningStatus)}{' '}
          {intl.formatMessage(messages.madeOn)} {decisionDate}{' '}
          {intl.formatMessage(messages.by)} {decisionUserFullName}
        </Typography>
      )}
      {isCreateAdverseActionLetterShown && (
        <>
          <Button
            variant="text"
            startIcon={<PlusIcon />}
            sx={{
              width: 'fit-content',
            }}
            onClick={createAdverseActionLetterModalProps.handleOpen}
          >
            {intl.formatMessage(messages.createAdverseActionLetter)}
          </Button>
          <AdverseActionLetterModal
            intl={intl}
            promptToaster={promptToaster}
            applicationId={applicationId}
            adverseActionDeadlineDays={adverseActionDeadlineDays}
            screeningLetterTypes={screeningLetterTypes}
            organizationId={organizationId}
            propertyId={propertyId}
            screeningData={screeningData}
            {...createAdverseActionLetterModalProps}
          />
        </>
      )}
    </Stack>
  );
}

export default FinalDecisionForm;
